import React, { Fragment } from 'react'
import styles from './email-required.styles'
import injectSheet from 'react-jss'
import Wrapper from '../../../../wrapper/wrapper'
import Container from '../../../../container/container'
import Description from '../../../../description/description'
import duck from '../../../../images/su-duck.gif'
import bear from '../../../../images/su-bear.gif'
import dinosaur from '../../../../images/su-dinosaur.png'
import CancelSignup from '../cancel-signup/cancel-signup.container'
import Form from './form/form.container'
import CheckInboxMessage from '../../../../check-inbox-message/check-inbox-message'

const accountTypeMap = {
  teacher: {
    title: 'Join Pobble as a teacher',
    containerProps: { primary: true, img: duck }
  },
  user: {
    title: 'Join Pobble as a parent',
    containerProps: { secondary: true, img: bear }
  },
  notChosen: {
    title: 'Join Pobble today',
    containerProps: { neutral: true, img: dinosaur }
  }
}

const EmailRequired = ({
  classes,
  accountType,
  options,
  identityConnectMessageSent
}) => {
  const accountData = !accountType
    ? accountTypeMap.notChosen
    : accountTypeMap[accountType]
  return (
    <Wrapper>
      <Container {...accountData.containerProps}>
        {!identityConnectMessageSent && (
          <Fragment>
            <Description title={accountData.title} />
            <Form
              suggestedEmail={options.suggested_email}
              afterSingleSignOn={options.after_single_sign_on}
            />
          </Fragment>
        )}
        {identityConnectMessageSent && <CheckInboxMessage />}
      </Container>
      {!identityConnectMessageSent && <CancelSignup />}
    </Wrapper>
  )
}

export default injectSheet(styles)(EmailRequired)
